
import { addSocketMessageListener } from "@/api/socketAPI";
import SocketMessageType from "@/constants/SocketMessageType";
import { store } from "@/store/store";
import { meetingAPI } from "@/api";

const updateMeetingAgendaData = async ( { body, } ) => {
	const { meetingId, } = body;
	const agendaMeetingId = store.getters[ "meetingAgenda/agendaMeetingId" ];

	if ( meetingId !== agendaMeetingId ) {
		return;
	}

	try {
		const options = { version: 2, };
		const meeting = await meetingAPI.getMeeting( { meetingId, }, options );
		store.dispatch( "meetingAgenda/updateAgenda", { meeting, } );
	} catch ( e ) {
		console.error( "error updating schedule store", body, e );
		// TODO: implementation
	}
};

export const initWebSocketListeners = () => {
	[
		SocketMessageType.MEETING_UPDATED,
		SocketMessageType.OUTCOME_CREATED,
		SocketMessageType.OUTCOME_DELETED,
		SocketMessageType.OUTCOME_UPDATED,
		SocketMessageType.TOPIC_CREATED,
		SocketMessageType.TOPIC_DELETED,
		SocketMessageType.TOPIC_UPDATED,
	].forEach( messageType => addSocketMessageListener( messageType, updateMeetingAgendaData ) );
};



// WEBPACK FOOTER //
// ./src/store/modules/meetingAgenda/agendaApiOrchestrator.js